//Blog
//blog-grid
export const gridCardsData = [
  {
      id: 1,
      gridSrc: '1.jpg',
      aboutSrc: '1.png',
      name: 'Erin M. Baker',
      date: 'Feb 6,2024',
      title: 'Mobile App Development',
      paragraph: 'Mobile Simple log in – logging in to your website is easyThey have added a dedicated login page inside the app.',
      views: '8k'
  },
  {
      id: 2,
      gridSrc: '2.jpg',
      aboutSrc: '2.png',
      name: 'Amy A. Servants',
      date: 'Feb 2,2024',
      title: 'Publish Policy',
      paragraph: 'The new rules classify companies with more than 45 million users as very.The laptop visible with some text and icons on it.',
      views: '2k'
  },
  {
      id: 3,
      gridSrc: '3.jpg',
      aboutSrc: '3.png',
      name: 'Jackie M. Martin',
      date: 'Feb 9,2024',
      title: 'Cozy Workspace',
      paragraph: 'The image is designed to convey a sense of comfort and warmth, as seen from the soft lighting and the cozy wooden.',
      views: '8k'
  },
  {
      id: 4,
      gridSrc: '4.jpg',
      aboutSrc: '4.png',
      name: 'Mary S. Jelks',
      date: 'Jan 25,2024',
      title: 'Take the stress out of code',
      paragraph: 'Are you wondering how to get a text short code and get start with reaching your customers in new SMS into steps.',
      views: '5k'
  },
  {
      id: 5,
      gridSrc: '5.jpg',
      aboutSrc: '5.png',
      name: 'Kathe W. Williams',
      date: 'Jan 5,2024',
      title: 'Myths about code',
      paragraph: "All of the paragraphs in the are written by humans. thought about to generate the paragraph, but they weren't very.",
      views: '4k'
  },
  {
      id: 6,
      gridSrc: '6.jpg',
      aboutSrc: '6.png',
      name: 'Anna G. Proas',
      date: 'Dec 31, 2024',
      title: 'Old School Coded',
      paragraph: 'Particular I learned about our mental and physical limits,the nature of stress and anxiety, and most importantly.',
      views: '11k'
  }
]

export const latestNewsData = [
  {
      id: 1,
      title: 'Top Men’s Fashion Trends From Spring',
      paragraph: 'Offer budget-friendly alternatives and shopping tips for men who want to stay on-trend without breaking the bank, such as shopping at thrift stores or opting for affordable brands.',
      date: '25 May 2024',
      comment: '10'
  },
  {
      id: 2,
      title: 'Spicy Crispy Chicken Burger Recipe',
      paragraph: 'Share tips for meal prepping burger components ahead of time, such as preparing the chicken patties in advance or making extra sauce for later use, provide tips for the perfect crispy chicken.',
      date: '15 July 2024',
      comment: '11'
  },
  {
      id: 3,
      title: 'Headsets Are Better if You’re Playing Game',
      paragraph: 'Explain how headsets with surround sound capabilities improve spatial awareness in games, allowing players to pinpoint the direction of in-game sounds such as footsteps or gunfire.',
      date: '14 June 2024',
      comment: '18'
  },
  {
      id: 4,
      title: 'Mistakes You Might Be Making With Watch',
      paragraph: 'Overwinding mechanical watches can cause serious damage to the movement. Content could explain how to properly wind mechanical watches and recognize when they are fully wound.',
      date: '10 April 2024',
      comment: '15'
  }
]

export const trendingPostsData = [
  {
      id: '01',
      title: 'Mistakes You Might Be Making With Watch',
      date: 'June 29, 2024'
  },
  {
      id: '02',
      title: 'Top Men’s Fashion Trends From Spring',
      date: 'May 11, 2024'
  },
  {
      id: '03',
      title: 'Surprising Benefits of Honeydew Melon',
      date: 'March 25, 2024'
  },
  {
      id: '04',
      title: 'Spicy Crispy Chicken Burger Recipe',
      date: 'July 17, 2024'
  },
  {
      id: '05',
      title: 'Headsets Are Better if You’re Playing Games',
      date: 'April 22, 2024'
  }
]

export const recentPostsData = [
  {
      id: 1,
      image: '1.jpg',
      title: 'Gadgets That Will Upgrade Your Home',
      time: '4 months ago'
  },
  {
      id: 2,
      image: '2.jpg',
      title: 'Headsets Are Better if You’re Playing Games',
      time: '5 months ago'
  },
  {
      id: 3,
      image: '3.jpg',
      title: 'Laugh, Cry and Learn Within Virtual Reality',
      time: '7 months ago'
  },
  {
      id: 4,
      image: '4.jpg',
      title: 'Mistakes You Might Be Making With Your Watch',
      time: '8 months ago'
  }
]

export const popularTagsData = ['Design', 'Clean', 'CSS3', 'Portfolio', 'Pixelstrap', 'Perfect', 'No Jquery']

export const blogCommentData = [
  {
      id: 1,
      image: '4.jpg',
      name: 'Sophia Johnson',
      date: '12 May 2024 at 1:30AM',
      paragraph: 'The gig economy is changing the way we work and the nature of employment. It offers flexibility and opportunities for freelancers, but it also raises questions about job security and benefits. Ethical considerations are paramount when it comes to technology and business. Companies need to prioritize transparency, accountability, and responsible use of data to build trust with customers and stakeholders.'
  },
  {
      id: 2,
      image: '7.jpg',
      name: 'Noah Johnson',
      date: '18 April 2024 at 5:25AM',
      paragraph: 'Cybersecurity is a major concern for businesses of all sizes. With the rise of cyber threats, investing in robust security measures is non-negotiable for protecting sensitive data and maintaining customer trust.'
  },
  {
      id: 3,
      image: '16.jpg',
      name: 'James Martinez',
      date: '15 August 2024 at 4:15AM',
      paragraph: "It's fascinating to see how businesses are leveraging technology to stay competitive in today's market. The innovations in AI and data analytics are truly game-changers, digital transformation is essential for businesses to thrive in the digital age. It's not just about adopting new technologies but also about reshaping organizational culture and processes."
  },
]

//Add Post
export const dataTypeahead = [{ name: 'Lifestyle' }, { name: 'Travel' }];

export const postEditRadios = [
  { id: 1, text: 'Text' },
  { id: 2, text: 'Image' },
  { id: 3, text: 'Audio', check: 'checked' },
  { id: 4, text: 'Video' },
];
